import React from 'react';

/**
 * Banner beta persistente até gate WCAG AA (SDD-10 Fase 3).
 * Remover quando LUDi for canónico oficial.
 */
export default function LudiBetaBanner({ className = '' }) {
  return (
    <div
      role="status"
      className={`border-b border-amber-500/35 bg-amber-500/12 px-ludi-4 py-ludi-2 text-center text-ludi-caption font-semibold text-amber-100 ${className}`}
    >
      Versão beta — interface em evolução. O checkout de subscrição é real.
    </div>
  );
}
